module.exports = __webpack_public_path__ + "img/59.6d20ef8a.jpg";